import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest } from 'redux-saga/effects';

import { getPreAlertAPI, getPreAlertEncryptAPI } from './api';
import {
  getPreAlert,
  getPreAlertPdf,
  getPreAlertPdfSuccess,
  getPreAlertSuccess,
  getPreAlertEncrypt,
  getPreAlertPdfEncrypt,
} from './slice';

function* preAlertSaga({ payload }: any) {
  const { onSuccess, onFail, ...data } = payload;

  try {
    const response: ResponseGenerator = yield call(getPreAlertAPI, { ...data, isPDF: 0 });
    if (onSuccess) {
      onSuccess(response.data);
      return;
    }
    yield put(getPreAlertSuccess(response.data));
  } catch (error) {
    onFail();
  }
}

function* preAlertPdfSaga({ payload }: any) {
  const { ...data } = payload;

  try {
    const response: ResponseGenerator = yield call(getPreAlertAPI, { ...data, isPDF: 1 });
    yield put(getPreAlertPdfSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

function* preAlertEncryptSaga({ payload }: any) {
  const { onSuccess, onFail, ...data } = payload;

  try {
    const response: ResponseGenerator = yield call(getPreAlertEncryptAPI, { ...data, isPDF: 0 });
    if (onSuccess) {
      onSuccess(response.data);
      return;
    }
    yield put(getPreAlertSuccess(response.data));
  } catch (error) {
    onFail();
  }
}

function* preAlertPdfEncryptSaga({ payload }: any) {
  const { ...data } = payload;

  try {
    const response: ResponseGenerator = yield call(getPreAlertEncryptAPI, { ...data, isPDF: 1 });
    yield put(getPreAlertPdfSuccess(response.data));
  } catch (error) {
    console.log(error);
  }
}

function* watchPreAlert() {
  yield takeLatest(getPreAlert, preAlertSaga);
  yield takeLatest(getPreAlertPdf, preAlertPdfSaga);
  yield takeLatest(getPreAlertEncrypt, preAlertEncryptSaga);
  yield takeLatest(getPreAlertPdfEncrypt, preAlertPdfEncryptSaga);
}

export default watchPreAlert;
